import DashboardLayout from "../components/Dashboard/Layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "../components/GeneralViews/NotFoundPage.vue";
import Forbidden from "../components/GeneralViews/Forbidden.vue";

// Dashboard pages
const Overview = () =>
  import(
    /* webpackChunkName: "widgets" */ "src/components/Dashboard/Views/Dashboard/Overview.vue"
  );
const Widgets = () =>
  import(
    /* webpackChunkName: "widgets" */ "src/components/Dashboard/Views/Dashboard/Widgets.vue"
  );

// Pages
// import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
// import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from "src/components/Dashboard/Views/Pages/Login.vue";
// import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
// import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'
import Logout from "src/components/Dashboard/Views/Pages/Logout.vue";

// Components pages
// import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
// import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
// import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
// import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
// import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
// import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
// import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
// const RegularForms  = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/RegularForms.vue')
// const ExtendedForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ExtendedForms.vue');
// const ValidationForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ValidationForms.vue')
// const Wizard = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/Wizard.vue');
// const Wizard = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Purchase/PurchaseV2.vue');

// TableList pages
// const RegularTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/RegularTables.vue');
// const ExtendedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/ExtendedTables.vue');
// const PaginatedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/PaginatedTables.vue');
// Maps pages
// const GoogleMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/GoogleMaps.vue')
// const FullScreenMap = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/FullScreenMap.vue')
// const VectorMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue');

// Calendar
// import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
// const Charts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Charts.vue')

// Site Pages
import Site from "src/components/Dashboard/Views/Sites/Site.vue";
import SiteList from "src/components/Dashboard/Views/Sites/SiteList.vue";
import Leaflet from "src/components/Dashboard/Views/Maps/LeafletMap.vue";
import Purchase from "src/components/Dashboard/Views/Purchase/Purchase.vue";
import Booking from "src/components/Dashboard/Views/Booking/Booking.vue";
import { Table } from "element-ui";
import PurchaseV2 from "src/components/Dashboard/Views/Purchase/PurchaseV2.vue";
import BookingList from "src/components/Dashboard/Views/Booking/BookingList.vue";
import Station from "src/components/Dashboard/Views/Sites/Station.vue";

// User management pages
const UserList = () =>
  import(
    /* webpackChunkName: "tables" */ "src/components/Dashboard/Views/UserManagement/UserList.vue"
  );
const PermissionList = () =>
  import(
    /* webpackChunkName: "tables" */ "src/components/Dashboard/Views/UserManagement/PermissionList.vue"
  );
const RoleList = () =>
  import(
    /* webpackChunkName: "tables" */ "src/components/Dashboard/Views/UserManagement/RoleList.vue"
  );
const User = () =>
  import(
    /* webpackChunkName: "tables" */ "src/components/Dashboard/Views/UserManagement/User.vue"
  );

// let componentsMenu = {
//   path: '/components',
//   component: DashboardLayout,
//   redirect: '/components/buttons',
//   children: [
//     {
//       path: 'buttons',
//       name: 'Buttons',
//       component: Buttons
//     },
//     {
//       path: 'grid-system',
//       name: 'Grid System',
//       component: GridSystem
//     },
//     {
//       path: 'panels',
//       name: 'Panels',
//       component: Panels
//     },
//     {
//       path: 'sweet-alert',
//       name: 'Sweet Alert',
//       component: SweetAlert
//     },
//     {
//       path: 'notifications',
//       name: 'Notifications',
//       component: Notifications
//     },
//     {
//       path: 'icons',
//       name: 'Icons',
//       component: Icons
//     },
//     {
//       path: 'typography',
//       name: 'Typography',
//       component: Typography
//     }

//   ]
// }
// let formsMenu = {
//   path: '/forms',
//   component: DashboardLayout,
//   redirect: '/forms/regular',
//   children: [
//     {
//       path: 'regular',
//       name: 'Regular Forms',
//       component: RegularForms
//     },
//     {
//       path: 'extended',
//       name: 'Extended Forms',
//       component: ExtendedForms
//     },
//     {
//       path: 'validation',
//       name: 'Validation Forms',
//       component: ValidationForms
//     },
//     {
//       path: 'wizard',
//       name: 'Wizard',
//       component: Wizard
//     }
//   ]
// }

// let tablesMenu = {
//   path: '/table-list',
//   component: DashboardLayout,
//   redirect: '/table-list/regular',
//   children: [
//     {
//       path: 'regular',
//       name: 'Regular Tables',
//       component: RegularTables
//     },
//     {
//       path: 'extended',
//       name: 'Extended Tables',
//       component: ExtendedTables
//     },
//     {
//       path: 'paginated',
//       name: 'Paginated Tables',
//       component: PaginatedTables
//     }]
// }

// let mapsMenu = {
//   path: '/maps',
//   component: DashboardLayout,
//   redirect: '/maps/google',
//   children: [
//     {
//       path: 'google',
//       name: 'Google Maps',
//       component: GoogleMaps
//     },
//     {
//       path: 'full-screen',
//       name: 'Full Screen Map',
//       component: FullScreenMap
//     },
//     {
//       path: 'vector-map',
//       name: 'Vector Map',
//       component: VectorMaps
//     }
//   ]
// }

// let pagesMenu = {
//   path: '/pages',
//   component: DashboardLayout,
//   redirect: '/pages/user',
//   children: [
//     {
//       path: 'user',
//       name: 'User Page',
//       component: User
//     },
//     {
//       path: 'timeline',
//       name: 'Timeline Page',
//       component: TimeLine
//     }
//   ]
// }

let userManagement = {
  path: "/users",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "User Page List",
      component: UserList
    }
  ]
};

let userPage = {
  path: "/users/:userId",
  component: DashboardLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "User Page",
      component: User
    }
  ]
};

let permission = {
  path: "/permissions",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "Permission Page",
      component: PermissionList
    }
  ]
};

let role = {
  path: "/roles",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "Role Page",
      component: RoleList
    }
  ]
};

let loginPage = {
  path: "/login",
  name: "Login",
  component: Login,
  meta: {
    requiresVisitor: true
  }
};

let logoutPage = {
  path: "/logout",
  name: "Logout",
  component: Logout
};

// let registerPage = {
//   path: '/register',
//   name: 'Register',
//   component: Register
// }

// let lockPage = {
//   path: '/lock',
//   name: 'Lock',
//   component: Lock
// }

// let sitePage = {
//   path: '/sites',
//   component: DashboardLayout,
//   // redirect: '/pages/user',
//   children: [
//     {
//       path: '',
//       name: 'Site List',
//       component: SiteList
//     },
//     {
//       path: ':siteId',
//       name: 'Site Page',
//       component: Site,
//       children: [
//         {
//           path: 'bookings',
//           name: 'Booking Page',
//           component: Booking
//         }

//       ]
//     }
//   ]
// }

let siteListPage = {
  path: "/sites",
  component: DashboardLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "Site List",
      component: SiteList
    }
  ]
};

let sitePage = {
  path: "/sites/:siteId",
  component: DashboardLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "Site Page",
      component: Site,
      props: true
    }
  ]
};

let stationPage = {
  path: "/sites/:siteId/stations/:stationId",
  component: DashboardLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "Station Page",
      component: Station,
      props: true
    }
  ]
};

let bookingListPage = {
  path: "/bookings",
  component: DashboardLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "Booking List",
      component: BookingList
    }
  ]
};

let bookingPage = {
  path: "/bookings/:bookingId",
  component: DashboardLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "Booking Page",
      component: Booking
    }
  ]
};

let leafPage = {
  path: "/leaflet",
  component: DashboardLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "Leaflet",
      component: Leaflet
    }
  ]
};

let purchasePage = {
  path: "/purchase",
  component: DashboardLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "Purchase Page",
      component: PurchaseV2
    }
  ]
};

const routes = [
  // {
  //   path: '/',
  //   component: DashboardLayout,
  //   redirect: '/admin/overview',
  //   children: [
  //     {
  //       path: 'calendar',
  //       name: 'Calendar',
  //       component: Calendar
  //     },
  //     {
  //       path: 'charts',
  //       name: 'Charts',
  //       component: Charts
  //     },
  //   ]
  // },
  loginPage,
  sitePage,
  leafPage,
  purchasePage,
  siteListPage,
  logoutPage,
  bookingListPage,
  bookingPage,
  userManagement,
  stationPage,
  permission,
  role,
  userPage,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/overview",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "overview",
        name: "Overview",
        component: Overview
      }
    ]
  },
  { path: "*", redirect: { name: "not-found" } },
  { path: "/404", name: "not-found", component: NotFound },
  { path: "/403", name: "forbidden", component: Forbidden }
];

export default routes;
